module.exports = "<header class=\"masthead clearfix\">\n  <div class=\"inner\">\n    <a routerLink=\"/\"><img src=\"assets/img/vortex_logo_blue.svg\" class=\"img-responsive\" alt=\"Vortex\"></a>\n    <img src=\"assets/img/maestro_logo_blue.svg\" class=\"img-responsive maestro-logo img-sm\" alt=\"MaestroLINK\">\n  </div>\n</header>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/header/header.html
// module id = ./src/app/main/components/header/header.html
// module chunks = main